module.exports = __webpack_public_path__ + "static/media/madball-logo@3x.58cec02a.png";